export const compiledForProd = process.env.NODE_ENV === "production";
export const deployTarget = process.env.ESBUILD_DEPLOY_TARGET;

export const isProdDeployTarget = deployTarget === "production";
export const isDemoDeployTarget = deployTarget === "demo";

export const isProd = compiledForProd && isProdDeployTarget;
export const isDemo = compiledForProd && isDemoDeployTarget;
export const isDev = !compiledForProd;

export const devlog = (message) => {
  if (!isProd) {
    console.log(`devlog: ${message}`);
  }
};

// Function to throttle handling of events
// see https://garden.bradwoods.io/notes/javascript/performance/debounce-throttle#throttle
export const throttle = (func, waitMS = 200) => {
  let isWait = false;

  return function (...args) {
    if (!isWait) {
      func.call(this, ...args);
      isWait = true;

      setTimeout(() => {
        isWait = false;
      }, waitMS);
    }
  };
};

export const ensureScriptLoaded = ({ src, id }) => {
  if (!document.getElementById(id)) {
    const scriptElement = document.createElement("script");
    scriptElement.src = src;
    scriptElement.id = id;
    scriptElement.async = true;
    document.head.appendChild(scriptElement);
  }
};
